const list: any = new Array(6).fill(0);

export default function ListSkeleton() {
  return (
    <div>
      {list.map((v: any, i: any) => (
        <div className="cardBox" key={i}>
          <div className="skeletonImg" />
          <div className="box">
            <div className="skeletonName" />
            <div className="skeletonModel" />
            <div className="skeletonPrice" />
          </div>
        </div>
      ))}
      <style jsx>{`
        .skeleton {
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 112px;
          padding: 16px;
          background-color: #fff;
          border-radius: 10px;
          margin-bottom: 10px;
        }

        .skeletonCheck {
          flex: 0 0 auto;
          width: 21px;
          height: 21px;
          margin-right: 15px;
          border-radius: 50%;
        }

        .skeletonContent {
          flex: 1 1 auto;
          display: flex;
          flex-direction: row;
        }

        .skeletonImg {
          width: 120px;
          height: 120px;
          border-radius: 3px;
          margin-right: 10px;
          animation: skeleton-stripes 1s linear infinite;
        }

        .skeletonInfo {
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          padding-left: 14px;
          padding-top: 7px;
        }

        .skeletonName {
          height: 14px;
          margin-bottom: 40px;
          width: 140px;
          animation: skeleton-stripes 1s linear infinite;
        }

        .skeletonModel {
          width: 120px;
          height: 12px;
          margin-bottom: 14px;
          animation: skeleton-stripes 1s linear infinite;
        }

        .skeletonPrice {
          width: 140px;
          height: 13px;
          animation: skeleton-stripes 1s linear infinite;
        }

        .skeletonBg {
          animation: skeleton-stripes 1s linear infinite;
        }

        .box {
          height: 120px;
          background: #ffffff;
          border-radius: 10px;
          padding: 15px;
          flex: 1;
        }

        .cardBox {
          padding: 0 16px;
          padding-bottom: 10px;
          background-color: #ffffff;
          display: flex;
          margin-bottom: 20px;
        }

        @keyframes skeleton-stripes {
          0% {
            background: rgba(240, 240, 240, 0.6);
          }
          50% {
            background: rgba(240, 240, 240, 1);
          }
          to {
            background: rgba(240, 240, 240, 0.6);
          }
        }
      `}</style>
    </div>
  );
}
